import Toast from './BaseToast.js'

Toast.install = (app, options) => {
  const toast = new Toast(options).show
  app.config.globalProperties.$baseToast = toast
  app.provide('baseToast', toast)
  app.component('baseToast', Toast)
}

export default Toast
